import React, { useEffect, useState } from 'react'
import { Box, Button, InputAdornment, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import SearchIcon from '@mui/icons-material/Search'
import DeleteIcon from '@mui/icons-material/Delete'
import { Colors } from '../../../../Styles/Colors'
import { CommonEditButton, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import Loader from '../../../../Components/Loader'
import DocCusCertTempCreation from './DocCusCertTempCreation'
import { useHistory } from 'react-router-dom'
export default function DocCustomCertTemplate() {
    const [templateData, setTemplateData] = useState([])
    const history = useHistory()
    const [searchText, setSearchText] = useState('')
    const [selectedIds, setSelectedIds] = useState([])
    const [isDelete, setIsDelete] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [errorMsg, setErrorMsg] = useState(false)
    const [errorMsgText, setErrorMsgText] = useState('')
    const [successMsg, setSuccessMsg] = useState(false)
    const [successMsgText, setSuccessMsgText] = useState('')
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [showCreation, setShowCreation] = useState(false)
    const [editData, setEditData] = useState(null)

    useEffect(() => {
        getTemplateData()
    }, [])

    const getTemplateData = () => {
        setIsLoader(true)
        try {
            RestAPIService.getAll(Serviceurls.CUSTOM_CERTIFICATE_TEMPLATE)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setTemplateData(response?.data?.data || [])
                    }
                    setIsLoader(false)
                }).catch((error) => {
                    setIsLoader(false)
                    showError(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            setIsLoader(false)
            showError(error.message)
        }
    }

    const showError = (msg) => {
        setErrorMsgText(msg)
        setErrorMsg(true)
    }

    const showSuccess = (msg) => {
        setSuccessMsgText(msg)
        setSuccessMsg(true)
    }

    const msgClose = () => {
        setErrorMsg(false)
        setErrorMsgText('')
        setSuccessMsg(false)
        setSuccessMsgText('')
    }

    const handleDelete = () => {
        setIsLoader(true)
        try {
            RestAPIService.delete(Serviceurls.CUSTOM_CERTIFICATE_TEMPLATE + `?id=${selectedIds.join(',')}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        showSuccess(response?.data?.message)
                        getTemplateData()
                        setSelectedIds([])
                        setIsDelete(false)
                    }
                    setIsLoader(false)
                }).catch((error) => {
                    setIsLoader(false)
                    showError(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            setIsLoader(false)
            showError(error.message)
        }
    }

    const filteredData = templateData.filter((row) => {
        const search = searchText.toLowerCase()
        return (
            row?.form_code?.toLowerCase()?.includes(search) ||
            row?.template_name?.toLowerCase()?.includes(search) ||
            row?.status?.toLowerCase()?.includes(search)
        )
    })

    filteredData.forEach((item, index) => { item.sno = index + 1 })

    const columns = [
        // {
        //     field: 'form_code', headerName: 'Form Code', flex: 0.25,
        //     renderCell: (params) => (
        //         <Tooltip placement="top" title={params.row.form_code || ''}>
        //             <Typography fontSize={'0.9vw'}>{params.row.form_code || '-'}</Typography>
        //         </Tooltip>
        //     )
        // },
        {
            field: 'template_name', headerName: 'Template Name', flex: 0.45, sortable: false,
            renderCell: (params) => (
                <Tooltip placement="top" title={params.row.template_name || ''}>
                    <Typography fontSize={'0.9vw'}>{params.row.template_name || '-'}</Typography>
                </Tooltip>
            )
        },
        {
            field: 'status', headerName: 'Status', flex: 0.2, sortable: false,
            renderCell: (params) => (
                <Typography fontSize={'0.9vw'}>{params.row.is_active ? 'Active' : 'Inactive'}</Typography>
            )
        },
        {
            field: 'action', headerName: '', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <CommonEditButton
                    disable={selectedIds.length > 0}
                    size="1.5vw"
                    onClick={() => {
                        history.push({
                            pathname: '/DoctorSettings/CustomCertificateTemplate/Template',
                            state: { editData: params.row }
                        });
                    }}
                />
            )
        }
    ]

    if (showCreation) {
        return (
            <DocCusCertTempCreation
                editData={editData}
                goBack={() => { 
                    setShowCreation(false); 
                    setEditData(null)
                    getTemplateData()
                }}
            />
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            {/* Top Action Bar */}
            <Box component={'div'} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: '.5vw' }}>
                <Button
                    variant='contained'
                    sx={{
                        textTransform: 'uppercase',
                        backgroundColor: '#04B7B1',
                        '&:hover': { backgroundColor: '#039e99' },
                        fontSize: '0.8vw',
                        fontWeight: 'bold',
                        padding: '0.4vw 1vw',
                    }}
                    onClick={() => { history.push('/DoctorSettings/CustomCertificateTemplate/Template') }}
                >
                    Add Template
                </Button>
            </Box>

            {/* Table Card */}
            <Box component={'div'} sx={{ height: '72vh', width: '93vw', backgroundColor: 'white', padding: '.5vw' }}>
                {/* Table Toolbar */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '.5vw' }}>
                    <Box>
                        {selectedIds.length > 0 && (
                            <Button
                                variant='contained'
                                color='error'
                                startIcon={<DeleteIcon />}
                                sx={{ textTransform: 'uppercase', fontSize: '0.8vw', fontWeight: 'bold', padding: '0.4vw 1vw' }}
                                onClick={() => setIsDelete(true)}
                            >
                                Delete
                            </Button>
                        )}
                    </Box>
                    <TextField
                        size='small'
                        placeholder='Search...'
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='start'>
                                    <SearchIcon sx={{ fontSize: '1.2vw', color: '#9e9e9e' }} />
                                </InputAdornment>
                            )
                        }}
                        sx={{ width: '15vw', '& .MuiInputBase-input': { fontSize: '0.85vw' } }}
                    />
                </Box>

                {/* DataGrid */}
                <DataGrid
                    checkboxSelection
                    selectionModel={selectedIds}
                    onSelectionModelChange={(ids) => setSelectedIds(ids)}
                    rows={filteredData}
                    columns={columns}
                    getRowId={(row) => row.id}
                    disableSelectionOnClick
                    disableColumnFilter
                    disableColumnSelector
                    disableColumnMenu
                    headerHeight={40}
                    density='compact'
                    pagination
                    paginationMode='client'
                    page={page}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    rowCount={filteredData.length}
                    loading={isLoader}
                    localeText={{
                        toolbarColumns: '',
                        toolbarDensity: '',
                        toolbarExport: '',
                        toolbarFilters: '',
                        toolbarExportPrint: ''
                    }}
                    components={{
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    sx={{ height: '63vh' }}
                />
            </Box>

            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
            {isDelete && (
                <DeletePopup
                    ButtonText={'Delete'}
                    DeletTitle={`Are you sure you want to delete the selected template(s)?`}
                    removeData={handleDelete}
                    deleteAlertPopupClose={() => { setIsDelete(false) }}
                />
            )}
            <Loader loaderOpen={isLoader} />
        </Box>
    )
}
